import React, { Component, Fragment } from 'react';
import {Link} from 'react-router-dom';
import DocumentMeta from 'react-document-meta';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {fetchArticles} from '../helpers/redux/actions/articlesActions';
import axios from 'axios';

export class articleDetail extends Component {
    constructor(props){
        super(props);
        this.state={
            book:{},
            allDatas:[],
            articleId:''
        }
    }


    componentWillMount(){
        const {state}=this.props.location;
        let ArticleId = window.location.href.split("/article/");

        if(state!==undefined && state.datas!==undefined){
            console.log("MASUK SINII");
            const {datas} = this.props.location.state;
            this.setState({
                articles:datas
            })
        }else{
            axios.get("https://gameintourney.com/wp-json/better-rest-endpoints/v1/articles/"+ArticleId[1])
            .then(res => {
                console.log("RESPONCE =",res.data);
                this.setState({
                    articles:res.data
                })
            })
            .catch(err => console.log(err))
        }
    }

    render() {
        const {articles,allDatas} = this.state;
        const meta = {
            title: 'TITLE FROM DETAIL',
            description: 'I am a description, and I can create multiple tags',
            canonical: 'http://example.com/path/to/page',
            meta: {
              charset: 'utf-8',
              name: {
                keywords: 'react,meta,document,html,tags'
              }
            }
        };

        if(articles!==undefined){
            return (
                <DocumentMeta {...meta}>
                    <Fragment>
                        <div className="container mt-5 mb-5 articleDetail">
                            <div className="col">
                                <h1>{articles.title}</h1>
                                <div dangerouslySetInnerHTML={{__html: articles.content}} className="mt-4 mb-4"></div>
                                <h4 className="mb-5">Publisher: {articles.acf.publisher}</h4>
                                <Link to={{ pathname:'/',state:{articles:allDatas} }} className="link">Go Back</Link>
                            </div>
                        </div>
                    </Fragment>
                </DocumentMeta>
            )
        }

        return <h3>Loading...</h3>
    }
}

articleDetail.propTypes = {
    fetchArticles:PropTypes.func.isRequired,
    articles:PropTypes.array.isRequired 
}

const mapStateToProps = state => ({
    articles:state.articles.datas
})

export default connect(mapStateToProps,{fetchArticles})(articleDetail);